import axios from "axios";
import { Cookies } from "react-cookie";
import { AddToastNotification } from "../ToastNotification/ToastNotificationManager";
//import { AddInfoBoxMessage } from "../InfoBoxManager";


const getDefaultAxios = (url) => {
    const cookies = new Cookies();

    const defaultAxios = axios.create({
        baseURL: window.api_url + 'api/AdminPanel/'+ url,
        headers: { Authorization: "Bearer " + cookies.get("jwt"), "Content-Type": "application/json" },
    });
    
    defaultAxios.interceptors.request.use((config) => 
    {
        config.headers.Authorization = "Bearer " + cookies.get("jwt");
        return config;
    })

    defaultAxios.interceptors.response.use((response) => response, (error) => {
        AddToastNotification(error.message + ` [${error.config.url}]`, 0);
        console.error(error);

        return Promise.reject(error);
    });

    return defaultAxios;
}

export  { getDefaultAxios };